class NonReactiveStateClass {
    messageDisplayed = false;
}

const NonReactiveState = new NonReactiveStateClass();

export default NonReactiveState;
